import {createSelector} from 'reselect';
import {getAresSignOffsByIds} from './selectors';

const getMarkCompleteMainSlice = (store) => store.markCompleteTasks;

const getMarkCompleteTasksSlice = (store) => getMarkCompleteMainSlice(store).tasks;
const getMarkCompleteDocumentsSlice = (store) => getMarkCompleteMainSlice(store).documents;

export const getMarkCompleteAllTasks = createSelector([getMarkCompleteTasksSlice], (tasksSlice) => {
	const byIdSlice = tasksSlice.byId;
	return tasksSlice.allIds.map((taskId) => byIdSlice[taskId]);
});

export const getMarkCompleteTasksByFilter = createSelector(
	[getMarkCompleteAllTasks, (store, filter) => filter],
	(tasks, filter) => {
		const _filter = filter || ((task) => true);
		return tasks.filter((task) => _filter(task));
	}
);

export const getMarkCompleteTaskByTaskId = (store, taskId) => {
    const tasksSlice = getMarkCompleteTasksSlice(store);
    return tasksSlice?.byId[taskId];
};

export const getMarkCompleteAllDocuments = createSelector([getMarkCompleteDocumentsSlice], (documentsSlice) => {
	const byIdSlice = documentsSlice.byId;
	return documentsSlice.allIds.map((docId) => byIdSlice[docId]);
});

export const getMarkCompleteDocumentsByFilter = createSelector(
    [getMarkCompleteAllDocuments, (store, filter) => filter],
    (documents, filter) => {
        const _filter = filter || ((doc) => true);
        return documents.filter((doc) => _filter(doc));
    }
);

export const getTaskById = (store, taskId) => {
    return getMarkCompleteTasksByFilter(store, (task) => task.id === taskId)[0];
}

export const getMarkCompleteDocumentById = (store, documentId) => {
    const documentsSlice = getMarkCompleteDocumentsSlice(store);
    return documentsSlice?.byId[documentId];
};

export const getTaskDocumentsSignOffsCount = (state, taskDocuments) => {
	let signOffsCount = 0;

    if (taskDocuments?.length > 0) {
        for (const documentId of taskDocuments) {
            if (documentHasBothSignOffs(state, documentId)) {
                signOffsCount++;
            }
        }
    }
	return signOffsCount;
};

const documentHasBothSignOffs = (state, documentId) => {
    const approvalIds = getMarkCompleteDocumentsSlice(state).byId[documentId]?.approvals || [];
    let approvals = getAresSignOffsByIds(state, approvalIds);

    const hasPreparer = approvals.some((approval) => approval.isPreparer === true);
    const hasReviewer = approvals.some((approval) => approval.isPreparer === false);

    return hasPreparer && hasReviewer;
}

export const readyForMarkComplete = (state, taskId) => {
    const task = getMarkCompleteTasksSlice(state).byId[taskId];
    const documentIds = task?.documents || [];
    return documentIds.every((docId) => documentHasBothSignOffs(state, docId));
}

export const tasksReadyForMarkComplete = (state, tasks) => {
    let result = tasks.map((task) => {
        let taskId = task.id;
        return { id: taskId, ready: readyForMarkComplete(state, taskId) };
    });

    return result.reduce((acc, task) => {
        return {
            ...acc,
            [task.id]: task.ready
        }
    }, {});
}
